import { registerMutation } from 'data-fetching-client';
import { rpcClient } from '../client';
import { postUpgradePointInteractionRpc } from 'upgrade-management-service-types';
export const submitInteraction = ({
  upgradeKey
}) => rpcClient.call(postUpgradePointInteractionRpc, {
  pathParameters: {
    upgradeKey
  }
});
export const TRACK_UMS_INTERACTION = registerMutation({
  fieldName: 'umsInteraction',
  args: ['upgradeKey'],
  fetcher: submitInteraction
});